<h2 mat-dialog-title class="bg-primary !text-white">
  {{ data?.listItem?.id ? 'Edit' : 'Add' }} List
</h2>
<mat-dialog-content>
  <ciwc-manage-saved-lists
    #manageSavedLists
    [listId]="data?.listItem?.id"
    [data]="data"
    (saveList)="onSaveList($event)"
  ></ciwc-manage-saved-lists>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button [mat-dialog-close]="true" mat-flat-button type="button" [disabled]="loading$()">
    Cancel
  </button>
  <div></div>
  <button
    mat-flat-button
    color="primary"
    (click)="manageSavedLists.submit()"
    [disabled]="loading$()"
    class="flex items-center gap-2"
  >
    <span class="inline-flex items-center gap-2">
      <mat-spinner *ngIf="loading$()" diameter="20"></mat-spinner>
      Save
    </span>
  </button>
</mat-dialog-actions>
